const workerHousingView = (data) => {
    let formData = data && data.getWorkerHousingById && data.getWorkerHousingById.WorkerHousingFormData
    if(formData){  
        let view = {
            name: formData.new_profile_worker_housing_profile_name,
            sections: [
                {
                    name: 'Worker Housing',
                    fields: [
                        {
                            number: 1,
                            label: 'Profile Name',
                            value: formData.new_profile_worker_housing_profile_name
                        },
                        {
                            number: 2,
                            label: 'Type of Housing',
                            value: formData.new_profile_worker_housing_type_of_housing,

                        },
                        {
                            number: 3,
                            label: 'Address',
                            value: formData.new_profile_worker_housing_physical_location_address,
                        },
                        {
                            number: 3,
                            label: 'City',
                            value: formData.new_profile_worker_housing_physical_location_city,
                        },
                        {
                            number: 4,
                            label: 'State',
                            value: formData.new_profile_worker_housing_physical_location_state
                        },
                        {
                            number: 5,
                            label: 'County',
                            value: formData.new_profile_worker_housing_physical_location_county && formData.new_profile_worker_housing_physical_location_county.label
                        },
                        {
                            number: 6,
                            label: 'Zip Code',
                            value: formData.new_profile_worker_housing_physical_location_zip_code
                        },
                        {
                            number: 7,
                            label: 'Housing Information',
                            value: formData.new_profile_worker_housing_additional_housing_information
                        },
                        {
                            number: 8,
                            label: 'Total Units',
                            value: formData.new_profile_worker_housing_total_units
                        },
                        {
                            number: 9,
                            label: 'Total Occupancy',
                            value: formData.new_profile_worker_housing_total_occupancy
                        },
                        
                    ]
                }
            ]
        }
        return view;
    }
}

export default workerHousingView